import list from 'src/modules/usageLog/list/usageLogListReducers';
import view from 'src/modules/usageLog/view/usageLogViewReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  view,
});
